import { ContractInformation } from 'api/v1/information'
import {
  MarketIndexes,
  MarketPriceConfigResponse,
  MarketPriceResponse,
  MarketTrades,
} from 'api/v1/market'
import { Price, SymbolName, Timestamp } from 'types'

export enum TradeType {
  Spot,
  Perp,
  None,
}
export interface MarketBarData {
  time: Timestamp
  open: Price
  high: Price
  low: Price
  close: Price
  volume: number
  value: number
}
export interface MarketPrice {
  LONG: string
  SHORT: string
}
export interface LastBar {
  symbol?: string
  time: Timestamp
  open: Price
  close: Price
  low: Price
  high: Price
  volume: number
  isBarClosed?: boolean
}

export interface Ticker {
  timestamp: number
  open: number
  high: number
  low: number
  close: number
  volume: number
  value: number
  percent: number
} // [timestamp, open, high, low, close, volume, value]
export interface Tickers {
  [x: SymbolName]: Ticker
}

export interface MarketState {
  trade: TradeType | ''
  trades: MarketTrades
  indexes: MarketIndexes
  tickers: Tickers
  marketBar: MarketBarData
  marketPrice: MarketPriceResponse
  marketPriceConfig: MarketPriceConfigResponse | undefined
  lastBar: LastBar
  contractInformation: Partial<ContractInformation>
  externalPrices: Record<SymbolName, number>
}
